import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AdminUsersListComponent } from './admin-users-list/admin-users.list.component';
import { AdminUserDetailComponent } from './admin-user-detail/admin-user-detail.component';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { AdminUserPermissionConfiguratorComponent } from '../admin-user-permission-configurator/admin-user-permission-configurator.component';

const routes: Routes = [
  {
    path: 'adminUsers',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: AdminUsersListComponent },
      { path: 'new', component: AdminUserDetailComponent, canDeactivate: [UnloadGuard] },
      { path: ':userId', component: AdminUserDetailComponent, canDeactivate: [UnloadGuard] },
      {
        path: 'rights-configurator/:userId',
        component: AdminUserPermissionConfiguratorComponent,
        canDeactivate: [UnloadGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AdminUsersRoutingModule {}
